import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Feedback } from "../../types/common.types";

interface FeedbackState {
  feedbacks: Feedback[];
  averageRating: number;
  totalReviews: number;
  ratingDistribution: { [key: number]: number };
  currentPage: number;
  limit: number;
  hasMore: boolean;
  isLoadingMore: boolean;
}

const initialState: FeedbackState = {
  feedbacks: [],
  averageRating: 0,
  totalReviews: 0,
  ratingDistribution: { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 },
  currentPage: 1,
  limit: 10,
  hasMore: true,
  isLoadingMore: false,
};

export const FeedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    setFeedbacks: (state, action: PayloadAction<FeedbackState>) => {
      state.feedbacks = action.payload.feedbacks;
      state.averageRating = action.payload.averageRating;
      state.totalReviews = action.payload.totalReviews;
      state.ratingDistribution = action.payload.ratingDistribution;
      state.currentPage = action.payload.currentPage;
      state.limit = action.payload.limit;
      state.hasMore = action.payload.feedbacks.length >= action.payload.limit;
      state.isLoadingMore = false;
    },
    appendFeedbacks: (
      state,
      action: PayloadAction<{
        feedbacks: Feedback[];
        currentPage: number;
        limit: number;
      }>
    ) => {
      state.feedbacks = [...state.feedbacks, ...action.payload.feedbacks];
      state.currentPage = action.payload.currentPage;
      state.hasMore = action.payload.feedbacks.length >= action.payload.limit;
      state.isLoadingMore = false;
    },
    clearFeedbacks: (state) => {
      state.feedbacks = [];
      state.averageRating = 0;
      state.totalReviews = 0;
      state.ratingDistribution = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
      state.currentPage = 1;
      state.limit = 100;
      state.hasMore = true;
      state.isLoadingMore = false;
    },
    setLoadingMore: (state, action: PayloadAction<boolean>) => {
      state.isLoadingMore = action.payload;
    },
  },
});

export const { setFeedbacks, appendFeedbacks, clearFeedbacks, setLoadingMore } =
  FeedbackSlice.actions;
export default FeedbackSlice.reducer;
